<template>
  <div class="order-page">
    <el-card class="box-card">
      <el-form :model="form"
               label-width="85px"
               style="width: 100%">

        <el-row>
          <el-col :span="6">
            <el-form-item prop="type"
                          label="报表">
              <el-select clearable
                         v-model="form.type"
                         placeholder="请选择报表..."
                         @change="changeType"
                         style="width: 100%">
                <el-option v-for="item in type_list"
                           :key="item.value"
                           :label="item.name"
                           :value="item.value">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item prop="platCode"
                          label="行业">
              <el-select clearable
                         v-model="form.profession"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in platlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="business"
                          label="商家">
              <el-select v-loading="ptnListLoading"
                         clearable
                         v-model="form.business"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in ptnlists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="store"
                          label="店铺">
              <el-select v-loading="shopListLoading"
                         clearable
                         v-model="form.store"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in shoplists"
                           :key="item.id"
                           :label="item.name"
                           :value="item.code">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>

          <el-col :span="6"
                  v-if="form.type !=12">
            <el-form-item prop="create_time"
                          label="日期">
              <el-date-picker v-model="form.time"
                              type="monthrange"
                              range-separator="至"
                              start-placeholder="开始月份"
                              end-placeholder="结束月份"
                              format="yyyy 年 MM 月"
                              value-format="yyyy-MM"
                              style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6"
                  v-if="form.type==12">
            <el-form-item prop="create_timeA"
                          label="时间段A">
              <el-date-picker v-model="form.timeA"
                              type="monthrange"
                              range-separator="至"
                              start-placeholder="开始月份"
                              end-placeholder="结束月份"
                              format="yyyy 年 MM 月"
                              value-format="yyyy-MM"
                              style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6"
                  v-if="form.type==12">
            <el-form-item prop="create_timeB"
                          label="时间段B">
              <el-date-picker v-model="form.timeB"
                              type="monthrange"
                              range-separator="至"
                              start-placeholder="开始月份"
                              end-placeholder="结束月份"
                              format="yyyy 年 MM 月"
                              value-format="yyyy-MM"
                              style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6"
                  v-if="form.type==5">
            <el-form-item prop="create_time"
                          label="日期">

              <el-date-picker v-model="form.time"
                              type="month"
                              placeholder="选择月"
                              format="yyyy 年 MM 月"
                              value-format="yyyy-MM"
                              style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col> -->

          <el-col :span="6"
                  v-if="form.type==5">
            <el-form-item prop="type"
                          label="范围">
              <el-select clearable
                         v-model="form.interval"
                         placeholder="请选择范围..."
                         style="width: 100%">
                <el-option v-for="item in [{'name':'3个月','value':3},{'name':'6个月','value':6},{'name':'12个月','value':12}]"
                           :key="item.value"
                           :label="item.name"
                           :value="item.value">{{ item.name }}</el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="备注">
              <el-input v-model="form.remark"
                        clearable
                        style="width: 100%"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="button-box">
      <el-row>
        <el-col>
          <el-button type="primary"
                     :loading="loading"
                     @click="handleClick">导出</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-col>
      </el-row>
    </el-card>
    
  </div>
</template>

<script>
import {
  getplatlists,
  getptnlists,
  getshoplists,
  gettradestatus,
  gettradefrom,
} from '@/common/mixins/select'
import SearchMixin from '@/common/mixins/search-mixin'
import ActionLine from '@/common/mixins/action-line'
import { dealReturn } from '@/common/js/index.js'
import * as Desc from './desc'
const tempPrefixeUrl = 'http://test.databankapi.transecs.com/'
export default {
  mixins: [getplatlists, getptnlists, getshoplists, gettradefrom],
  data() {
    return {
      form: {
        type: '',
        profession: '',
        store: '',
        business: '',
        time: '',
        remark: '',
        timeA: [],
        timeB: [],
        interval: '',
      },
      dialogData: this.form,
      loading: false,
      tableData: [],
      msg: '',
      Desc,
      reportTypeList: [],
      'label-width': '90px',
      type_list: [
        { name: '销售额单月', value: 1 },
        { name: '顾客继续新规', value: 2 },
        { name: '顾客Recency&运转率', value: 3 },
        { name: '顾客F×M累计', value: 4 },
        { name: '顾客level报表', value: 5 },
        { name: '顾客继续-既存', value: 6 },
        { name: '顾客继续-整体', value: 7 },
        { name: '销售额移动和', value: 8 },
        { name: '顾客存活', value: 9 },
        { name: '顾客FM累计-12个月', value: 10 },
        { name: '商品-新客', value: 11 },
        { name: '商品-交叉营销', value: 12 },
        { name: '商品-继续', value: 13 },
      ],
    }
  },
  created() {
    // this.getTableData();
    // this.getOperatelogReporttype()
  },
  methods: {
    changeType() {
      this.form.remark = ''
      this.form.time = []
      this.form.timeA = []
      this.form.timeB = []
      if (this.form.type != 5) {
        console.log('change')

        if (this.form.interval) {
          this.form.interval = ''
        }
      } else {
        this.form.time = []
      }
      // if (this.form.type != 12) {
      //   console.log('change12')
      //   this.form.timeA = []
      //   this.form.timeB = []
      //   this.form.time = []
      // } else {
      //   delete this.form.time
      //   this.form.timeA = []
      //   this.form.timeB = []
      // }
      console.log(this.form)
    },
    resetForm() {
      this.form = {
        type: '',
        interval: '',
        profession: '',
        store: '',
        business: '',
        time: '',
        remark: '',
        timeB: [],
        timeA: [],
      }
    },
    handleClick() {
      // if (!this._collectQuery()) {
      //   return
      // }
      if (this.form.type == 12) {
        if (!this.form.timeA) {
          this.$message.error('请选择时间段A')
          return
        }
        if (!this.form.timeB) {
          this.$message.error('请选择时间段B')
          return
        }
      }
      if (this.form.type == 5) {
        if (!this.form.interval) {
          this.$message.error('请选择范围')
          return
        }
      }
      if (!this.form.type) {
        this.$message.error('请选择报表类型')
        return
      }

      if (!this.form.store) {
        this.$message.error('请先选择店铺')
        return
      }
      if (this.form.type != 12) {
        if (!this.form.time) {
          this.$message.error('请选择时间')
          return
        }
      }

      var formData = {
        type: this.form.type,
        profession: this.form.profession,
        store: this.form.store,
        business: this.form.business,
        remark: this.form.remark,
      }
    
      if (this.form.type == 12) {
        (formData.timeA = this.form.timeA), (formData.timeB = this.form.timeB)
      } else{
        formData.time = this.form.time
      }

      if (this.form.type == 5) {
        formData.interval = this.form.interval
      }

      // this.getData()
      console.log('this.queryPrdlists', this.queryPrdlists)
      console.log(this.form)
      this.rfmReport(formData)
    },

    async rfmReport(formData) {
      this.loading = true
      let { data, err } = await this.axiosApi(Desc.rfm_api, formData)
      console.log('data', data)
      this.loading = false
      if (data && data.data.meta.status == 200) {
        this.$alert('导出成功，请稍后在导出日志查看', '导出成功', {
          confirmButtonText: '确定',
          type: 'success',
        })
      }
      dealReturn(data, err)
    },
  },
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/views/rfm/rfmPrdList.bak/index.vue